import type { AppTab } from "../../../shared/inApp";

/**
 * The phone's tabs and the routes each one holds: a goal's own pages belong to Home (as to the Command Center on
 * a computer), a partner to Products, Connections to More, which opens it. The phone app keeps one screen per tab
 * (flashsuite-phone docs/APP-MODE.md); the bar draws them in this order.
 */
export const TAB_PLACES = [
  { id: "home", to: "/command", area: ["/command", "/goals"] },
  { id: "needs", to: "/needs", area: ["/needs"] },
  { id: "products", to: "/products", area: ["/products", "/partners"] },
  { id: "library", to: "/library", area: ["/library"] },
  { id: "more", to: "/more", area: ["/more", "/connections"] },
] as const satisfies readonly AppTab[];

export type TabId = (typeof TAB_PLACES)[number]["id"];

/** The screens a tab opens. Any screen pushed on top of one hides the bar, as on the phone. */
export function isTabRoot(pathname: string): boolean {
  const p = pathname.replace(/\/+$/, "") || "/";
  return TAB_PLACES.some((t) => t.to === p);
}
